import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs/Rx';

@Injectable()
export class ApplicationBroadcaster {
  private loginSubject: Subject<boolean> = new Subject<boolean>();

  public loginSubscriber: Observable<boolean>;

  private dashboardSubject: Subject<boolean> = new Subject<boolean>();

  public dashboardSubscriber: Observable<boolean>;

  private configurationSubject: Subject<boolean> = new Subject<boolean>();

  public configurationSubscriber: Observable<boolean>;

  private saveEstimateSubject: Subject<boolean> = new Subject<boolean>();

  public saveEstimateSubscriber: Observable<boolean>;

  public workOrderType: string;

  public userId: string;

  constructor() {
    this.loginSubscriber = this.loginSubject.asObservable();
    this.configurationSubscriber = this.configurationSubject.asObservable();
    this.dashboardSubscriber = this.dashboardSubject.asObservable();
    this.saveEstimateSubscriber = this.saveEstimateSubject.asObservable();
  }

  loginBroadCast(value: boolean): void {
    this.loginSubject.next(value);
  }

  dashBoardBroadCast(value: boolean): void {
    this.dashboardSubject.next(value);
  }

  configurationBroadCast(value: boolean): void {
    this.configurationSubject.next(value);
  }

  saveEstimateBroadCast(value: boolean): void {
    this.saveEstimateSubject.next(value);
  }


}



// WEBPACK FOOTER //
// ./node_modules/@rx/core/applicationbroadcaster.ts